import { createSelector } from 'reselect';
import Empty from 'constants/empty';

const creatorProfileSelector = createSelector(
    state => state.page?.creatorStoreFrontData || Empty.Object,
    data => data.creatorProfileData || Empty.Object
);

export { creatorProfileSelector };
